<template>
  <section class="rock-table-search">
    <template v-for="(item, index) in columns">
      <div
        :key="'collapse' + index"
        :data-delay="(index - (currentLayout * 2 - 2)) * 100"
        :data-leaveDelay="(index % currentLayout) * 100"
        v-show="columnVisible(index)"
        :style="{
          width: `calc(100% / ${currentLayout} - 24px * ${
            currentLayout - 1
          } / ${currentLayout})`,
          marginLeft: index % currentLayout ? '24px' : '0',
        }"
        class="collapse-item"
      >
        <div :title="item.label.length > 14 ? item.label : ''" class="label">
          {{
            item.label.length > 14
              ? item.label.substring(0, 13) + '...'
              : item.label
          }}
        </div>
        <el-input
          v-if="item.type === 'input'"
          v-model.trim="ruleForm[item.field]"
          :placeholder="item.placeholder || '请输入'"
          :disabled="disabled(item)"
          :clearable="!item.hideClearable"
          :size="elSize"
          :maxlength="20"
        />
        <el-select
          v-if="item.type === 'select'"
          v-model="ruleForm[item.field]"
          :placeholder="item.placeholder || '请选择'"
          :disabled="disabled(item)"
          :multiple="item.multiple || false"
          collapse-tags
          :clearable="!item.hideClearable"
          :size="elSize"
          :filterable="item.filterable || true"
          :popper-append-to-body="false"
          @clear="
            () => {
              clearTag(item.field, ruleForm[item.field], false);
            }
          "
          @visible-change="
            (visible) => changeSelect(item.field, ruleForm[item.field], visible)
          "
          @remove-tag="() => clearTag(item.field, ruleForm[item.field], false)"
        >
          <el-option
            v-for="(option, index) in item.options"
            :key="item.field + 'option' + index"
            :value="
              option[
                item.props && item.props.value ? item.props.value : 'value'
              ]
            "
            :label="
              option[
                item.props && item.props.label ? item.props.label : 'label'
              ]
            "
          />
        </el-select>
        <!--            pickerType：year/month/date/dates/months/years week/datetime/datetimerange/ daterange/monthrange-->
        <el-date-picker
          v-if="item.type === 'date'"
          v-model="ruleForm[item.field]"
          :type="item.pickerType ? item.pickerType : 'date'"
          :placeholder="item.placeholder || '请选择'"
          :start-placeholder="item.startPlaceholder || '开始日期'"
          :end-placeholder="item.endPlaceholder || '结束日期'"
          :value-format="item.valueFormat || 'timestamp'"
          :size="elSize"
          :clearable="!item.hideClearable"
          :editable="false"
          :unlink-panels="true"
          :picker-options="{ disabledDate: disabledDate(item) }"
          :default-time="
            item.defaultTime
              ? item.defaultTime
              : item.startLinkField
              ? '23:59:59'
              : '00:00:00'
          "
        />
        <el-date-picker
          v-if="item.type === 'linkDatePicker'"
          v-model="ruleForm[item.field]"
          :size="elSize"
          :type="item.pickerType ? item.pickerType : 'daterange'"
          align="right"
          unlink-panels
          :value-format="item.valueFormat ? item.valueFormat : 'timestamp'"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :picker-options="{ disabledDate: disabledDate(item) }"
          :default-time="['00:00:00', '23:59:59']"
          @change="updateLinkTime(item)"
        />
        <el-cascader
          v-if="item.type === 'cascader'"
          v-model="ruleForm[item.field]"
          :placeholder="item.placeholder || '请选择'"
          :options="item.options"
          :props="item.props"
          :size="elSize"
          :show-all-levels="item.showAllLevels"
          :clearable="!item.hideClearable"
          :filterable="item.filterable || true"
          @change="
            ($event) => {
              //只取级联中二级选择的值
              if (item.level === 2) {
                ruleForm[item.field] = $event[1];
              }
            }
          "
        >
        </el-cascader>
        <el-input-number
          v-if="item.type === 'inputNumber'"
          v-model="ruleForm[item.field]"
          :size="elSize"
          :min="item.min || 0"
          :max="item.max || 10000"
          controls-position="right"
          style="width: 100%"
          :placeholder="item.placeholder || '请选择'"
        ></el-input-number>
      </div>
      <div
        v-if="placeholderBoxVisible(index)"
        :key="'br' + index"
        class="placeholder-box"
      />
    </template>
    <!--    <transition-group
            tag="div"
            :css="false"
            @before-enter="handleBeforeEnter"
            @enter="handleEnter"
            @after-enter="handleAfterEnter"
            @before-leave="handleBeforeLeave"
            @leave="handleLeave"
            @after-leave="handleAfterLeave"
        >

        </transition-group>-->
    <div key="button" class="search-btn-group">
      <vxe-button
        v-if="btnVisible()"
        type="text"
        :size="vxeSize"
        status="primary"
        :icon="fold ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"
        :content="fold ? '展 开' : '收 起'"
        @click="fold = !fold"
      />
      <vxe-button
        :size="vxeSize"
        icon="vxe-icon-repeat"
        content="重 置"
        @click="search(0)"
      />
      <vxe-button
        :size="vxeSize"
        status="primary"
        icon="vxe-icon-search"
        content="搜 索"
        @click="search(1)"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { hasOwn } from 'element-ui/src/utils/util';

export default {
  name: 'RockTableSearch',
  install(Vue) {
    Vue.component('RockTableSearch', this);
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
      require: true,
    },
  },
  data() {
    return {
      currentLayout: undefined,
      fold: true,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      elSize: 'elSize',
      screenWidth: 'screenWidth',
      vxeSize: 'vxeSize',
    }),
    ruleForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    screenWidth: {
      handler(val) {
        let num = 1;
        if (val >= 1650) num = 6;
        else if (val >= 1580) num = 5;
        else if (val >= 1340) num = 4;
        else if (val >= 1080) num = 3;
        else if (val >= 840) num = 2;
        else if (val >= 768) num = 1;
        else if (val >= 590) num = 2;
        this.currentLayout = num;
      },
      immediate: true,
    },
  },
  methods: {
    columnVisible(index) {
      return this.btnVisible() && this.fold
        ? index < this.currentLayout * 2 - 1
        : true;
    },
    btnVisible() {
      return this.columns.length > this.currentLayout * 2 - 1;
    },
    placeholderBoxVisible(index) {
      let visible = false;
      if (this.fold) {
        if (
          !this.btnVisible() &&
          !(this.columns.length % this.currentLayout) &&
          index === this.columns.length - 1
        )
          visible = true;
        else if (this.currentLayout === 1 && index === this.columns.length - 1)
          visible = true;
      } else {
        if (index % this.currentLayout === this.currentLayout) visible = true;
        else if (
          !(this.columns.length % this.currentLayout) &&
          index === this.columns.length - 1
        )
          visible = true;
      }
      return visible;
    },
    disabled(item) {
      if (hasOwn(item, 'disabled')) {
        if (typeof item.disabled === 'function') return item.disabled();
        if (typeof item.disabled === 'boolean') return item.disabled;
      } else return false;
    },
    handleBeforeEnter(dom) {
      let { x = 0, y = 0, s = 1, opacity = 0 } = dom.dataset;
      dom.style.cssText = `transition: .3s;opacity: ${opacity};transform: scale(${s}) translateX(${x}) translateY(${y}); width: ${dom.style.width}; margin-left:  ${dom.style.marginLeft};`;
    },
    handleEnter(dom, done) {
      let delay = dom.dataset.delay;
      setTimeout(function () {
        dom.style.cssText = `transition: .3s;opacity: 1;transform: scale(1) translateX(0) translateY(0); width: ${dom.style.width}; margin-left:  ${dom.style.marginLeft};`;
        //监听 transitionend 事件
        let transitionend = window.ontransitionend
          ? 'transitionend'
          : 'webkitTransitionEnd';
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd);
          done(); //调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
        });
      }, delay);
    },
    handleAfterEnter(dom) {
      dom.style.cssText = `width: ${dom.style.width}; margin-left:  ${dom.style.marginLeft};`;
    },

    handleBeforeLeave(dom) {
      let { x = 0, y = 0, s = 1, opacity = 1 } = dom.dataset;
      dom.style.cssText = `transition: .3s;opacity: ${opacity};transform: scale(${s}) translateX(${x}) translateY(${y}); width: ${dom.style.width}; margin-left:  ${dom.style.marginLeft};`;
    },
    handleLeave(dom, done) {
      let delay = dom.dataset.leavedelay;
      setTimeout(function () {
        dom.style.cssText = `transition: .3s;opacity: 0;transform: scale(1) translateX(0) translateY(0); width: ${dom.style.width}; margin-left:  ${dom.style.marginLeft};`;
        //监听 transitionend 事件
        let transitionend = window.ontransitionend
          ? 'transitionend'
          : 'webkitTransitionEnd';
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd);
          done(); //调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
        });
      }, delay);
    },
    handleAfterLeave(dom) {
      dom.style.cssText = `width: ${dom.style.width}; margin-left:  ${dom.style.marginLeft}; display: none;`;
    },

    disabledDate(column) {
      return (time) => {
        let disabled = false;
        if (column.disabledTodayAndBefore) {
          disabled = time.getTime() < new Date().getTime();
        } else if (column.disabledBeforeToday) {
          disabled = time.getTime() < new Date().getTime() - 3600 * 24 * 1000;
        } else if (column.disabledTodayAndAfter) {
          disabled = time.getTime() > new Date().getTime() - 3600 * 24 * 1000;
        } else if (column.disabledAfterToday) {
          disabled = time.getTime() > new Date().getTime();
        } else if (column.disabledBeforeHalfYear) {
          disabled =
            time.getTime() < dayjs().subtract(6, 'month') - 3600 * 24 * 1000 ||
            time.getTime() > dayjs();
        }

        if (column.endLinkField && this.ruleForm[column.endLinkField]) {
          disabled =
            disabled ||
            time.getTime() >
              new Date(this.ruleForm[column.endLinkField]).getTime();
        } else if (
          column.startLinkField &&
          this.ruleForm[column.startLinkField]
        ) {
          disabled =
            disabled ||
            (column.overlap
              ? time.getTime() <
                new Date(this.ruleForm[column.startLinkField]).getTime() -
                  3600 * 1000 * 24
              : time.getTime() <
                new Date(this.ruleForm[column.startLinkField]).getTime());
        }
        return disabled;
      };
    },

    search(isSearch) {
      this.$emit('search', isSearch);
    },
    resetData() {
      this.$forceUpdate();
    },
    changeSelect(node, nodeData, visible) {
      const obj = {
        node,
        nodeData,
        visible,
      };
      this.$emit('changeSelect', obj);
    },
    clearTag(node, nodeData, visible) {
      const obj = {
        node,
        nodeData,
        visible,
      };
      this.$emit('clearTag', obj);
    },
    // 处理联动的时间
    updateLinkTime(item) {
      if (item.defaultTime) {
        this.ruleForm[item.field[0]] = item.defaultTime[0];
        this.ruleForm[item.field[1]] = item.defaultTime[1];
        // this.$emit('input', this.ruleForm);
      } else {
        this.ruleForm[item.field[0]] = null;
        this.ruleForm[item.field[1]] = null;
        // this.$emit('input', this.ruleForm);
      }
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.el-range-editor--small .el-range-input) {
  padding: 0 6px;
}

.rock-table-search {
  position: relative;
  //display: flex;
  //flex-wrap: wrap;
  box-sizing: border-box;
  padding: 30px 30px 14px 30px;
  width: 100%;
  min-height: 92px;
  background: #ffffff;
  border-radius: 10px;
  //border: 1px dashed #1768cc

  .collapse-item {
    position: relative;
    display: inline-block;
    margin-bottom: 16px;
    margin-left: 24px;
  }

  .search-btn-group {
    position: absolute;
    right: 30px;
    bottom: 30px;
  }

  .placeholder-box {
    width: 100%;
    height: 42px;
    visibility: hidden;
  }

  //.collapse-list {
  //  width: 100%;
  //}

  .label {
    position: absolute;
    left: 9px;
    top: -8px;
    padding: 0 6px 0 6px;
    background: #fff;
    line-height: 1;
    z-index: 1;
    color: #606266;
    font-weight: bold;
  }

  .el-select {
    width: 100%;
  }

  .el-date-editor {
    width: 100%;
  }

  .el-cascader {
    width: 100%;
  }

  .vxe-button.size--medium {
    font-size: 12px;
  }
}

::v-deep.el-input-number > .el-input > .el-input__inner::placeholder {
  text-align: left !important;
}

::v-deep.el-input-number > .el-input > .el-input__inner {
  text-align: left !important;
}

::v-deep .el-select-dropdown__list {
  padding: 15px 0;
}
</style>
